<template>
  <article class="main app-main">
    <!-- <header>
      <h2 class="top-title">用户协议</h2>
    </header> -->
<p>您通过网络页面点击确认或同意接受《用户协议》（以下简称 “ 本协议 ” ），即视为您与鲲鹏保险经纪（北京）有限公司（以下简称 “ 鲲鹏保险经纪 ” ）已达成合意并接受本协议约定的内容（含客户告知书）。 在您确认接受本协议前，请您务必审慎阅读并充分理解本协议各条款的内容，尤其是免除或限制责任的条款、法律适用与管辖条款。<b>免除或限制责任的条款将以粗体标识，您应重点阅读。</b></p>

<p>如果您对协议内容有任何的疑问，可通过 4000613966 客服电话进行咨询。 在您确认接受本协议全部条款之前，请勿进行下一步操作。</p>

<p>一、服务提示</p>

<p>1.请您在投保前，认真评估保障需求，根据实际需要合理选择保险产品。如果您对保险产品的选择有任何的疑问，您可通过鲲鹏保险经纪平台（鲲鹏保险经纪（北京）有限公司运营的包括但不限于“小鱼惠保”微信公众号等其他微信公众号、小程序、网页、网站、APP等线上平台）或客服电话进行咨询，鲲鹏保险经纪将为您提供专业的咨询及解答服务。</p>

<p>2.<b>请您在投保前，务必点击网页上的保险条款、投保须知等链接，仔细阅读保险条款和投保须知等内容，了解保险责任、责任免除、犹豫期、费用扣除、退保损失、保险单现金价值等重要内容。</b></p>

<p>3.请您在投保前，<b>仔细阅读健康告知、职业要求等内容</b>，<b>并履行如实告知义务。若您未履行如实告知义务，保险公司将有权解除保险合同，并对保险合同解除前发生的保险事故不承担保险责任。</b></p>

<p>4.您通过本服务从事的交易可能面临以下风险,<b>这些风险需要您自行承担:</b></p>

<p><b>(1)监管风险:法律法规､监管政策和规定发生变化,导致您的交易目的无法实现,您由此可能遭受损失;</b></p>

<p><b>(2)违约风险:因保险公司无力或其他原因不能履约,您由此可能遭受损失;</b></p>

<p><b>(3)交易风险:您通过本服务所购买的保险产品最终没有达成交易,您无法获得保险产品和服务;</b></p>

<p><b>(4)过错风险：因您的过错导致的任何损失，包括决策失误、不诚信行为、操作不当、遗忘或泄漏密码、非本人操作或委托不当等。</b></p>

<p>5.<b>您在鲲鹏保险经纪平台提供或填写的信息（包括注册信息、投保信息等）应是真实、准确、合法有效的，如有变化，您应及时修改并重新提交。若因您提交的信息不真实、不准确、不合法或失效，您应承担由此引起的不利后果</b>。</p>

<p>6. 您在鲲鹏保险经纪平台的账户仅限您本人使用，不可转让、借用和赠与。<b>您在注册、绑定和关联鲲鹏保险经纪平台账户时，应使用您本人真实有效的身份信息和联系方式，包括身份证件、微信账户、银行账户、手机号码和电子邮箱等</b>。<b>您允许平台会不定期的向您预留或提供的联系方式、地址以站内信的方式发送通知消息、或以短信、电话、函件、等方式发送商业广告等。</b></p>

<p>7.您授权并同意鲲鹏保险经纪开通客户资金专用账户收取保费并按照与保险公司的约定将保费解付至保险公司。</p>

<p>8.<b>当您投保分期保险产品时，您点选自动续费选项后，鲲鹏保险经纪将依照您的授权从您账户中自动代扣保费。您应该保持保费支付账户的余额充足，余额不足时，将无法扣费成功，因此导致的保单失效、无法理赔等情况，由您自行承担损失。</b></p>

<p>二、协议的范围与性质</p>

<p>1.本协议是您与鲲鹏保险经纪之间订立的委托协议，而保险合同的订立和履行由您和保险公司共同合意完成。鲲鹏保险经纪基于您的合法权益，为您和保险公司之间订立保险合同提供经纪服务。</p>

<p>2.<b>您在使用鲲鹏保险经纪平台某一项服务时，该服务可能会另有单独的协议、业务规则等。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守</b>；</p>

<p>3.<b>您在鲲鹏保险经纪平台使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。鲲鹏保险经纪和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</b></p>

<p>三、协议的生效、变更与转让</p>

<p>1.您通过网络页面点击确认或同意接受本协议，或使用鲲鹏保险经纪平台的服务即视为您已阅读本协议并接受本协议的约束，本协议即刻生效；</p>

<p>2.鉴于互联网服务的特殊性，您授权并同意鲲鹏保险经纪根据国家法律法规和政策的变化及时修订本协议。修订后的协议将通过鲲鹏保险经纪平台向您公布，如您对本协议的修订有任何的疑问，可以拨打鲲鹏保险经纪客服电话进行咨询；</p>

<p>3.<b>本协议条款修改或变更后，如果您继续使用鲲鹏保险经纪提供的软件或服务，即视为您已接受修改后的协议。</b>如果您不接受修改后的协议，应当停止使用鲲鹏保险经纪提供的产品或服务；</p>

<p>4.<b>除非您与鲲鹏保险经纪另有约定外，您同意本服务仅为您本人使用，您依本协议条款所取得的权利不可转让</b>。</p>

<p>四、个人信息保护</p>

<p>保护您的个人信息是鲲鹏保险经纪的一项核心原则。鲲鹏保险经纪将按照本协议及《隐私声明》的规定收集、使用、储存、分享您的个人信息。本协议内容同时包括《隐私声明》，即为本协议不可分割的组成部分，您对本协议的接受，即视为您对《隐私声明》的接受。</p>

<p>五、行为规范</p>

<p>1.您在使用本服务时须遵守法律法规，不得利用本服务从事洗钱、窃取商业秘密、窃取个人信息等违法违规活动；</p>

<p>2.不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；</p>

<p>3.您不得利用鲲鹏保险经纪提供的服务从事任何牟利或经营活动；</p>

<p>4.您不得使用未经鲲鹏保险经纪授权的插件、外挂或第三方工具对本协议项下的服务进行干扰、破坏、修改或施加其他影响；</p>

<p>5.您违反本条约定，导致鲲鹏保险经纪或第三方损害的，您应当独立承担一切责任，包括但不限于：刑事责任、行政责任和民事责任。</p>

<p>六、免责事由</p>

<p>1.<b>您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，鲲鹏保险经纪将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失鲲鹏保险经纪在法律允许的范围内免责</b>；</p>

<p>2.<b>您同意下列情形已超出鲲鹏保险经纪控制与合理预见，若因此给您造成了损失，鲲鹏保险经纪可以免责</b>： </p>

<p><b>(1)您受到病毒、木马或其他恶意程序、黑客攻击的破坏； </b></p>

<p><b>(2)您的手机、电脑软件、系统、硬件和通信线路出现故障； </b></p>

<p><b>(3)您通过非鲲鹏保险经纪授权的方式使用本服务；</b></p>

<p><b>(4)您未点击和阅读保险条款、投保须知等内容；</b></p>

<p><b>(5)鲲鹏保险经纪平台页面展示和设计原因给您造成损失；</b></p>

<p><b>(6)鲲鹏保险经纪平台系统原因导致您未成功投保、续保或支付保费；</b></p>

<p><b>(7)鲲鹏保险经纪平台系统不稳定或故障、通讯故障、银行原因 、第三方服务瑕疵</b>。</p>

<p>3.除上述免责情形外，<b>非因鲲鹏保险经纪故意或重大过失给您造成损失的，鲲鹏保险经纪也可以免责</b>。</p>

<p>七、服务的变更、中断、终止</p>

<p>1.鲲鹏保险经纪可能会对服务内容进行变更，也可能会中断、中止或终止服务；</p>

<p>2.<b>您理解并同意，在鲲鹏保险经纪发生合并、分立、收购、资产转让时，鲲鹏保险经纪可向第三方转让本服务下相关资产。鲲鹏保险经纪也可在单方通知您后，将本协议下部分或全部服务转交由第三方运营或履行；</b></p>

<p>3<b>.如发生下列任何一种情形，鲲鹏保险经纪有权不经通知而中断或终止向您提供的服务：</b></p>

<p><b>（ 1 ）您提供的个人资料不真实、不准确、不合法或失效；</b></p>

<p><b>（ 2 ）您违反相关法律法规或本协议的约定； </b></p>

<p><b>（ 3 ）按照法律规定或主管部门的要求。 </b></p>

<p>八、法律适用与管辖</p>

<p>1.本协议的订立、效力、解释、履行及争议的解决均适用中华人民共和国法律。 因本协议引起的或与本协议有关的任何争议，应首先通过协商方式解决。<b>协商不成的，应将争议提交至本协议签订地北京市丰台区人民法院通过诉讼方式解决</b>。</p>

<p>2.<b>本协议名称、条款的标题仅为查阅方便而设置，不应构成对本协议的任何解释，不对标题之下的内容及范围作任何限定</b>。</p>

<p>九、投诉渠道与处理流程</p>

<p>1、如果您发现本公司有关人员有违法、违规行为，或认为自身权益受到侵犯，请您保留相关证据并向本公司投诉，投诉电话4000613966。</p>

<p>2、您的投诉将依照相关法律法规、合同约定，公平公正提出处理意见，报公司负责人审核同意后作出决定并向您反馈。对于事实清楚、争议情况简单的消费投诉，将自收到消费投诉之日起15个自然日内作出处理决定并告知您。按照监管部门规定，情况复杂的，可延长至30个自然日；情况特别复杂或者有其他特殊原因的，经公司负责人审批并告知投诉人，可再延长30个自然日。</p>


  </article>
</template>

<script>
export default {
  name: 'ServiceAgreement',
  components: {},
  mixins: [],
  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  destroyed() {
  },

  methods: {}
}
</script>

<style scoped lang="scss">
.main {
  padding: px2rem(15, 375);
  color: #333;
  padding-top: 0;
}

.top-title {
  text-align: center;
  font-size: px2rem(20, 375);
  margin-bottom: px2rem(20, 375);
}

section {
  line-height: 1.5;
}

.part-title {
  font-size: px2rem(14, 375);
  font-weight: bold;
  margin-bottom: px2rem(5, 375);
}

.user {
  font-weight: normal;
}

.clause-block {
  margin-bottom: px2rem(10, 375);
}

.part-content {
  font-size: px2rem(14, 375);
  text-indent: px2rem(28, 375);
  text-align: justify;
}

.text-underline {
  text-decoration: underline;
}
</style>